import { jsx, jsxs } from "react/jsx-runtime";
import { Button } from "../../..";
import { BoxStyled } from "./styled";
const ActionBarCustom = (props) => {
  return /* @__PURE__ */ jsxs(BoxStyled, { className: props.className, children: [
    " ",
    /* @__PURE__ */ jsx(Button, { size: "xs", onClick: props.onAccept, children: "Выбрать" })
  ] });
};
export {
  ActionBarCustom
};
